import { FilterType, Filter, FilterKey, OfferStatus } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const offerStatusOptions = [
  {
    label: 'For review',
    value: OfferStatus.FOR_REVIEW,
  },
  {
    label: 'Not resolved',
    value: OfferStatus.NOT_RESOLVED,
  },
  {
    label: 'Conditional',
    value: OfferStatus.CONDITIONAL,
  },
  {
    label: 'Unconditional',
    value: OfferStatus.UNCONDITIONAL,
  },
  {
    label: 'Removed',
    value: OfferStatus.REMOVED,
  },
  {
    label: 'Declined',
    value: OfferStatus.DECLINED,
  },
];

const key = FilterKey.CONDITIONAL_STATUS;
export const getConditionalStatusFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter | null => {
  const canFilterConditionalStatus = hasPerm(userRole || UserRole.Unknown, P.FILTER_CONDITIONAL_STATUS);
  if (!canFilterConditionalStatus) {
    return null;
  }

  const filters = activeFilters[key] ?? [];
  const options = offerStatusOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Overall conditional status',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
